import { useCallback } from 'react';
import { useForm, useWatch, UseFormOptions } from 'react-hook-form';

import { ContextCardForm } from '~/api/models/leadads/context-card';

const formConfig: UseFormOptions<ContextCardForm> = {
  defaultValues: {
    headline: 'Sign up to find properties that match your tastes!',
    paragraph: 'Sign up for an account to receive new property email alerts, price change alerts, detailed property information, track your favorite properties, foreclosures and much more!',
    list: [
      'New Property Email Alerts',
      'Price Change Alerts',
      'Detailed Property Information',
      'Save your property searches and favorite properties',
      'Agents to Answer Questions Online',
    ],
    layout: 'LIST_STYLE',
    image: null,
  },
};

export default function useContextCardFormState() {
  const formState = useForm<ContextCardForm>(formConfig);

  const layout = useWatch({
    control: formState.control,
    name: 'layout',
    defaultValue: 'LIST_STYLE',
  });

  const validateList = useCallback(() => {
    const { list } = formState.getValues();
    return !list.every(v => v === '') || 'You must have at least one content item in your list';
  }, [formState.getValues]);

  return {
    ...formState,
    layout,
    validateList,
  };
}
